import { datadogRum } from '@datadog/browser-rum';
import type { RumInitConfiguration } from '@datadog/browser-rum';

import type { RouteMatcher } from '@xing-com/crate-core-router';
import type { ErrorReporter } from '@xing-com/crate-xinglet';

export function setupDataDog(
  matchRoute: RouteMatcher,
  {
    applicationId,
    clientToken,
    service = 'crate-app',
    sessionSampleRate,
    version,
    ...options
  }: Partial<RumInitConfiguration> = {}
): ErrorReporter {
  const env = {
    'www.xing.com': 'production' as const,
    'preview.xing.com': 'preview' as const,
  }[document.location.hostname];

  if (!env || !applicationId || !clientToken) {
    return function ignoreError() {
      //
    };
  }

  datadogRum.init({
    allowedTracingUrls: [
      /^https:\/\/.*?\.xing\.com/,
      /^https:\/\/.*?\.lebenslauf\.com/,
      /^https:\/\/.*?\.anschreiben\.com/,
      /^https:\/\/.*?\.lebenslauf\.cc/,
      /^https:\/\/.*?\.anschreiben\.cc/,
      /^https:\/\/.*?\.nwse.io/,
    ],
    applicationId,
    clientToken,
    defaultPrivacyLevel: 'mask',
    env,
    service,
    sessionReplaySampleRate: 0,
    sessionSampleRate,
    site: 'datadoghq.eu',
    version,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    ...options,
    beforeSend: (event, _context) => {
      const { route, owner } = matchRoute(window.location.pathname);

      if (route) event.view.name = route;
      if (owner) Object.assign((event.context ??= {}), { owner });

      return true;
    },
  });

  datadogRum.setGlobalContextProperty('cost_center', '11131');
  datadogRum.setGlobalContextProperty('application', 'crate');

  return function reportError(error, context) {
    datadogRum.addError(error, context);
  };
}
